// client/src/routes/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, rolesPermitidos = [] }) => {
  const { usuario, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-gray-600 font-medium text-sm">Verificando sesión...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si es SuperAdmin, tiene acceso total (bypass de roles)
  if (usuario?.isSuperAdmin || usuario?.id_superadmin || usuario?.rol === "superAdmin") {
    return children;
  }

  // Si es Usuario normal, validar roles
  if (rolesPermitidos.length > 0 && !rolesPermitidos.includes(usuario?.rol)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
